import React, { useState, useEffect } from 'react';
import '../App.css';
import * as Colors from './colors'
import db from './firebase/firebase';

const ContactUs = () => {
    const [contactInfo, setContactInfo] = useState({});
    useEffect(() => {
        loadInfo()
    }, [])
    const loadInfo = async () => {
        let doc = await db.collection('contact-info')
            .doc('contact-info')
            .get()
        let data = doc.data()
        setContactInfo(data)
    }

    return (
        <div className='main'>

            <div className='login'>

                {/* <img
                    src={logo}
                    style={{ width: 200, objectFit: 'contain', alignSelf: 'center', marginBottom: 20 }} /> */}

                <div className='home-label' style={{ marginTop: 0, marginLeft: 0, alignSelf: 'center' }}>
                    Contact Us
                </div>

                <div style={{ marginTop: 20 }}>

                    <div>
                        <div className="list" style={{ marginTop: '.6rem' }}>
                            <span>Email: {contactInfo.email}</span>
                            <span>WhatsApp: {contactInfo.phone}</span>
                            <span>Address: {contactInfo.address}</span>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    )
}

export default ContactUs